import { Link } from 'react-router-dom';

export default function PublicFooter() {
  return (
    <footer className="bg-[#151b25] text-white">
      <div className="mx-auto max-w-7xl px-5 py-12 sm:px-8">
        <div className="grid gap-10 md:grid-cols-[1.4fr_0.8fr_0.8fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-orange-500 text-white">
                <i className="ri-music-2-fill text-xl" />
              </span>
              <div>
                <div className="font-heading text-xl font-black">PARTITURAS</div>
                <div className="text-[9px] font-extrabold uppercase tracking-[0.16em] text-orange-300">
                  pratique até dominar
                </div>
              </div>
            </div>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-slate-300">
              Ferramenta de apoio para iniciantes praticarem leitura musical entre uma aula e outra.
              O site não substitui o professor: ele ajuda a repetir, memorizar e acompanhar a evolução.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-extrabold text-white">Acesso</h3>
            <div className="mt-4 flex flex-col gap-2 text-sm text-slate-300">
              <Link to="/entrar" className="hover:text-orange-300">Entrar</Link>
              <Link to="/criar-conta?next=%2Faulas%2F1" className="hover:text-orange-300">Criar conta</Link>
              <Link to="/aulas" className="hover:text-orange-300">Área do aluno</Link>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-extrabold text-white">Método</h3>
            <div className="mt-4 flex flex-col gap-2 text-sm text-slate-300">
              <a href="#amostras" className="hover:text-orange-300">O que você aprende</a>
              <a href="#metodo" className="hover:text-orange-300">Como funciona</a>
              <a href="#evolucao" className="hover:text-orange-300">Evolução</a>
              <a href="#dicas" className="hover:text-orange-300">Dicas de prática</a>
              <a href="#historia" className="hover:text-orange-300">História e curiosidades</a>
              <a href="#ajuda" className="hover:text-orange-300">Ajuda</a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs text-slate-500 sm:flex-row sm:justify-between">
          <span>© 2026 Partituras · Versão de testes</span>
          <span>Conta, histórico e progresso salvos</span>
        </div>
      </div>
    </footer>
  );
}
